import { BaseSoundService } from './index';
import { SoundOptionsByGame } from '../../core/constants/soundOptionsByGame';
import { FAST_TRADE_PATH_NAME } from '../../core/constants/socketPathName';

class SoundService extends BaseSoundService {
  constructor(props) {
    super(props);
  }
}

const options =
  SoundOptionsByGame[
    window.location.pathname === '/' ? FAST_TRADE_PATH_NAME : window.location.pathname
  ];

const soundService = new SoundService({
  options,
});

export { soundService };
